import { render, staticRenderFns } from "./modal-popup.vue?vue&type=template&id=4fb709c4&scoped=true"
import script from "./modal-popup.vue?vue&type=script&lang=ts"
export * from "./modal-popup.vue?vue&type=script&lang=ts"
import style0 from "./modal-popup.vue?vue&type=style&index=0&id=4fb709c4&prod&lang=scss&scoped=true"
import style1 from "./modal-popup.vue?vue&type=style&index=1&id=4fb709c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb709c4",
  null
  
)

export default component.exports